import NiceModal, { useModal } from "@ebay/nice-modal-react";
import Modal from "/src/components/modal/Modal";
import useModalHelper from "/src/components/modal/hooks/useModalHelper";
import Form from "/src/components/form/Form";
import Button from "../../UI/Button/Button";

const ConfirmModal = NiceModal.create(({ title, body, confirmLabel, cancelLabel, danger }) => {
    const modal = useModal();
    const { onClose } = useModalHelper(modal);

    // The promise must always be settled: nice-modal does not do it when the modal is simply removed
    const close = (confirmed) => {
        modal.resolve(confirmed);
        onClose();
    };

    return (
        <Modal name="logout" id={modal.id} onClose={() => close(false)}>
            <div className="leave-container">
                <div className="button-leave" id="close_modal_container" onClick={() => close(false)}>
                    <i id="close_modal" className="fa fa-times" aria-hidden="true"></i>
                </div>
            </div>
            <Form className="modal-form" onSubmit={(e) => { e.preventDefault(); close(true); }}>
                <Form.Title>{title}</Form.Title>
                <Form.Body><p>{body}</p></Form.Body>
                <div style={{ display: 'flex' }}>
                    <Button className="validate" label={cancelLabel} style={{ margin: 10, marginRight: 20 }}onClick={() => close(false)}/>
                    <Button className={danger ? "cancel" : "validate"} label={confirmLabel} type="submit" style={danger ? { margin: 10 } : { margin: 10, backgroundColor: "var(--main)", color: "var(--white)" }} />
                </div>
            </Form>
        </Modal>
    );
});

ConfirmModal.defaultProps = {
    title: "Are you sure?",
    body: "",
    confirmLabel: "Confirm",
    cancelLabel: "Cancel",
    danger: false,
};

export default ConfirmModal;
